import React, { useRef } from 'react';

import ModalDirectors from './ModalDirectors';

import NunoBg from '../../../../../Images/modals/directors/nuno/bg_nuno.png';
import Video1 from '../../../../../Images/modals/directors/nuno/video-1.png';
import Video2 from '../../../../../Images/modals/directors/nuno/video-2.png';
import Video3 from '../../../../../Images/modals/directors/nuno/video-3.png';
import Video4 from '../../../../../Images/modals/directors/nuno/video-4.png';

import {
  Director_Nuno,
  Text_Nuno,
  TextVideo1_Nuno,
  TextVideo2_Nuno,
  TextVideo3_Nuno,
  TextVideo4_Nuno,
} from '../../../../../utils/ES/Modals/directors';

const ModalNuno = () => {
  return (
    <>
      <ModalDirectors
        id="director-nuno"
        mainBg={NunoBg}
        directorName={Director_Nuno}
        mainVideoBg={Video1}
        videoText1={TextVideo1_Nuno}
        directorText={Text_Nuno}
        rowImage1={Video2}
        videoText2={TextVideo2_Nuno}
        rowImage2={Video3}
        videoText3={TextVideo3_Nuno}
        rowImage3={Video4}
        videoText4={TextVideo4_Nuno}
        mainVideoLink={'nuno-video-1'}
        rowVideoLink1={'nuno-video-2'}
        rowVideoLink2={'nuno-video-3'}
        rowVideoLink3={'nuno-video-4'}
      />
    </>
  );
};

export default ModalNuno;
